import React from "react";

import VideoPlayer from "./VideoPlayer";

import { setSelectedIndex, showVideoPlayer } from "../actions";

import green from "../images/green_lg.gif";
import bright from "../images/bf_med.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

import { find } from "lodash";

import * as task_data from "../data/task.json";
import * as skill_details from "../data/skill_details.json";

const JobDetails = ({
    job,
    selectedIndex,
    videoPlayerVisible,
    clusters,
    dispatch,
}) => {
    if (job == null) return <React.Fragment />;

    let skills = skill_details.default;

    // function closeModal() {
    //     dispatch(showVideoPlayer(false));
    //     dispatch(setSelectedIndex(null));
    // }

    function changeIndex(step) {
        dispatch(setSelectedIndex(selectedIndex + step));
    }

    function displayVideoPlayer() {
        dispatch(showVideoPlayer(true));
    }

    let green_bright, bright_img, green_img;
    // if (job.is_green) {
    //     green_img = <img src={green} alt="green" />;
    // }
    if (job.is_bright) {
        bright_img = <img src={bright} alt="bright" />;
    }

    if (job.is_bright)
        green_bright = (
            <li>
                {/* {green_img} */}
                {bright_img}
            </li>
        );

    let task_object = find(task_data.default, { soc_code: job.soc_code });
    let tasks = task_object ? task_object.tasks : [];

    let video;
    if (job.video !== "") {
        const videoOptions = {
            autoplay: false,
            controls: true,
            sources: [
                {
                    src: `/prvideo/${job.video}.mp4`,
                    type: "video/mp4",
                },
            ],
        };

        video = <VideoPlayer {...videoOptions} />;
    }

    return (
        <div className="container job-details">
            <div className="row header align-items-center">
                <div className="col">
                    <h5 style={{ margin: 0, padding: "5px 0" }}>{job.job_title}</h5>
                </div>
                <div className="col-auto" style={{ paddingRight: "10px", whiteSpace: "nowrap" }}>
                    <button
                        type="button"
                        className="nav-button"
                        onClick={changeIndex.bind(this, -1)}
                    >
                        <span aria-hidden="true">&laquo;</span>
                    </button>
                    <button
                        type="button"
                        className="nav-button"
                        onClick={changeIndex.bind(this, 1)}
                    >
                        <span aria-hidden="true">&raquo;</span>
                    </button>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="row">
                        <div className="col-sm">
                            <strong>{job.soc_code}</strong>
                            <ul>
                                {green_bright}
                                <li>
                                    <a
                                        href={`https://online.onetcenter.org/link/summary/${job.soc_code}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Open O*Net Summary Page
                                        <FontAwesomeIcon
                                            icon={faExternalLinkAlt}
                                            size="sm"
                                            color="grey"
                                            style={{
                                                paddingLeft: "5px",
                                            }}
                                        />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={`https://online.onetcenter.org/link/summary/${job.soc_code}#WagesEmployment`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        O*Net Wages & Employment Trends
                                        <FontAwesomeIcon
                                            icon={faExternalLinkAlt}
                                            size="sm"
                                            color="grey"
                                            style={{
                                                paddingLeft: "5px",
                                            }}
                                        />
                                    </a>
                                </li>
                                {/* {job.video !== "" ? (
                                    <li>
                                        <button
                                            className="btn btn-link"
                                            style={{ padding: 0 }}
                                            onClick={displayVideoPlayer}
                                        >
                                            Watch Video
                                        </button>
                                    </li>
                                ) : (
                                    <React.Fragment />
                                )} */}
                            </ul>
                            <div
                                className={`d-${
                                    videoPlayerVisible ? "inline" : "none"
                                }`}
                            >
                                {video}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm">
                            <strong>Career Cluster</strong>
                            <p>
                                {job.clusters
                                    .map((cluster_tag) => {
                                        const c = find(clusters, { cluster_tag });
                                        return c ? c.cluster_desc : cluster_tag;
                                    })
                                    .join(", ")}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm">
                            <strong>O*Net Description</strong>
                            <p>{job.job_desc}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm">
                            <strong>ACT WorkKeys Skill Profile</strong>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Skill Area</th>
                                        <th>Median Skill Level</th>
                                        <th>Minimum Skill Level</th>
                                        <th>Maximum Skill Level</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {skills.map((skill) => (
                                        <tr key={`skill_${skill.skill_tag}`}>
                                            <td>{skill.skill_title}</td>
                                            <td>
                                                {
                                                    job[
                                                        skill.skill_tag.toLowerCase()
                                                    ]
                                                }
                                            </td>
                                            <td>
                                                {
                                                    job[
                                                        skill.skill_tag.toLowerCase() +
                                                            "_lo"
                                                    ]
                                                }
                                            </td>
                                            <td>
                                                {
                                                    job[
                                                        skill.skill_tag.toLowerCase() +
                                                            "_hi"
                                                    ]
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="row tasks">
                        <div className="col-sm">
                            {tasks.length > 0 ? (
                                <strong>Tasks:</strong>
                            ) : (
                                <React.Fragment />
                            )}
                            {tasks.map((task, i) => (
                                <p key={`task_${i}`}>{task}</p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobDetails;

/*
<div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={changeIndex.bind(this, -1)}
                    >
                        &laquo; Previous
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={changeIndex.bind(this, 1)}
                    >
                        Next &raquo;
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        data-dismiss="modal"
                        onClick={closeModal.bind(this)}
                    >
                        Close
                    </button>
                </div>*/
